var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuoteRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 55,
    viewBox: "0 0 50 55",
    fill: "#0061ED",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1328 27.2813L21.7266 1.8994e-06L29.1094 2.54482e-06L49.8516 26.6484V27.9844L29.1094 54.6328L21.7266 54.6328L41.1328 27.2813ZM19.4063 27.2813L4.77615e-06 0L7.38282 6.45426e-07L28.125 26.6484V27.9844L7.38281 54.6328H0L19.4063 27.2813Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteRight);
export default ForwardRef;